<template>
  <div>
    <div class="record-lists">
      <div class="center-border" v-if="logData.length > 0"></div>
      <div class="list flex-between" v-for="item in logData">
        <div class="left">
          <p class="left-date">
            {{ moment(item.createTime).format("YYYY-MM-DD") }}
          </p>
          <p class="left-time">
            {{ moment(item.createTime).format("HH:mm:ss") }}
          </p>
        </div>
        <div class="right">
          <p class="user-name">
            {{ logText(item) }}
          </p>
        </div>
      </div>
      <div v-if="logData.length == 0">无记录</div>
    </div>
  </div>
</template>
<script>
import moment from "moment";
export default {
  props: {
    orderId: String,
  },
  data() {
    return {
      logData: [],
      moment: moment,
      status: {
        0: "草稿",
        1: "新申请",
        2: "待客户确认",
        3: "待审核",
        4: "等待派工",
        5: "服务中",
        6: "已完成",
        7: "已关闭",
        8: "已取消",
      },
    };
  },
  methods: {
    logText(item) {
      if (item.objType == 300) {
        return `${item.handlerName} 创建外派工单 ${this.statusText(item)} `;
      } else if (item.objType == 301) {
        return `${item.handlerName} 开始处理 ${this.statusText(item)} `;
      } else if (item.objType == 302) {
        return `${item.extraData.oldHandler} 转移外派工单给 ${
          item.extraData.newHandler
        }  ${this.statusText(item)} `;
      } else if (item.objType == 310) {
        return `${item.handlerName} 提交方案 ${this.statusText(item)} `;
      } else if (item.objType == 304) {
        return `${item.handlerName} 修改方案 ${this.statusText(item)} `;
      } else if (item.objType == 320) {
        return `${item.handlerName} 确认方案 ${this.statusText(item)} `;
      } else if (item.objType == 321) {
        return `${item.handlerName} 代客户确认方案 ${this.statusText(item)} `;
      } else if (item.objType == 322) {

        // if (
        //   item.extraData &&
        //   item.extraData.oldHandler &&
        //   item.extraData.newHandler
        // ) {
        //   return `${item.extraData.oldHandler} 提交审批 ${
        //     item.extraData.newHandler
        //   }  ${this.statusText(item)} `;
        // } else {
        //   return `${item.handlerName} 提交审批 ${this.statusText(item)} `;
        // }
               if (
          item.extraData &&
          item.extraData.oldHandler &&
          item.extraData.newHandler
        ) {
          return `${item.extraData.oldHandler} 完成审批 ${
            item.extraData.newHandler
          }  ${this.statusText(item)} `;
        } else {
          return `${item.handlerName} 完成审批 ${this.statusText(item)} `;
        }
      } else if (item.objType == 323) {
        if (
          item.extraData &&
          item.extraData.oldHandler &&
          item.extraData.newHandler
        ) {
          return `${item.extraData.oldHandler} 提交审批给 ${
            item.extraData.newHandler
          }  ${this.statusText(item)} `;
        } else {
          return `${item.handlerName} 提交审批 ${this.statusText(item)} `;
        }
      } else if (item.objType == 330) {
        return `等待派工中${this.statusText(item)} `;
      } else if (item.objType == 331) {
        return `${item.handlerName} 创建外派人员 ${this.statusText(item)} `;
      } else if (item.objType == 332) {
        return `${item.handlerName} 审核通过 ${this.statusText(item)} `;
      } else if (item.objType == 340) {
        return `${item.handlerName} 服务中 ${this.statusText(item)} `;
      } else if (item.objType == 350) {
        return `${item.handlerName} 推送最终报告及费用 ${this.statusText(
          item
        )} `;
      } else if (item.objType == 370) {
        return `${item.handlerName} 有异议 ${this.statusText(item)} `;
      } else if (item.objType == 380) {
        return `${item.handlerName} 完成外派工单 ${this.statusText(item)} `;
      } else if (item.objType == 360) {
        return `${item.handlerName} 确认解决 ${this.statusText(item)} `;
      } else if (item.objType == 390) {
        return `外派工单关闭 ${this.statusText(item)} `;
      } else if (item.objType == 395) {
        return `${item.handlerName} 取消外派工单 ${this.statusText(item)} `;
      }
    },
    statusText(item) {
      if (item.extraData) {
        if (item.extraData.old != item.extraData.new) {
          if (
            item.extraData.new !== undefined &&
            item.extraData.old !== undefined
          ) {
            return `(${this.status[item.extraData.old]} 变更为 ${
              this.status[item.extraData.new]
            } )`;
          } else {
            return `(${this.status[item.extraData.old]})`;
          }
        } else {
          return `(${this.status[item.extraData.old]})`;
        }
      }
      return ""

    },
    getRecord() {
      let data = {
        objId: this.orderId,
        dataType: 1,
      };
      this.ccRequest
        .do("admin/fsb/work/order/node/query", data, "GET")
        .then((res) => {
          var recordData = [];
          for (var i = 0; i < res.rows.length; i++) {
            recordData.push(res.rows[res.rows.length - i - 1]);
          }
          this.logData = recordData;
        });
    },
  },
  mounted() {
    this.getRecord();
  },
};
</script>
<style lang="scss" scoped>
.record-lists {
  position: relative;
  background: #ffffff;
  padding: 20px;
  .center-border {
    position: absolute;
    width: 1px;
    height: 100%;
    background: #e4e4e4;
    left: 170px;
  }
  .list {
    margin-top: 20px;
    .left {
      width: 120px;
      text-align: right;
      margin-right: 30px;
      color: #bbb;
      .left-time {
        color: #1ab394;
        margin-top: 5px;
      }
    }
    .right {
      flex: 1;
      margin-left: 30px;
      border-bottom: 1px solid #e4e4e4;
      padding: 15px;
      padding-top: 45px;
      .user-name {
        font-size: 16px;
      }
      .text {
        margin-top: 10px;
        color: #aaa;
      }
    }
  }
}
</style>